<div class="title" [ngClass]="direction" [ngStyle]="style">
  <ng-content></ng-content>
</div>
